import styled from 'styled-components';
import { TypographyStyles, accordionAnimation, accordionArrowAnimation, colours, spacing } from '../../../stylings';
import { ShippingSection as ShippingSectionText } from '../../shippingSection';

export const AccordionContainer = styled.div<{ $isOpenDelivery: boolean }>`
  ${({ $isOpenDelivery }) => accordionAnimation($isOpenDelivery)}
  overflow: hidden;
  @media (prefers-reduced-motion) {
    display: ${({ $isOpenDelivery }) => ($isOpenDelivery ? 'unset' : 'none')};
  }
`;

export const AccordionHeading = styled.h2`
  margin: 0;
`;

export const Container = styled.div`
  margin-top: ${spacing.S};
`;

export const DeliveryAccordion = styled.button`
  align-self: center;
  background-color: transparent;
  border: 0;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  padding: 0;
  user-select: none;
  width: 100%;
`;

export const DeliveryLabel = styled.span`
  ${TypographyStyles.Body.Small.SemiBold}
  color: ${colours.BLACK};
  margin-right: ${spacing.XXXS};
  text-align: left;
`;

export const IconWrapper = styled.span<{ $isOpenDelivery: boolean }>`
  align-self: baseline; /* stylelint-disable-line order/properties-alphabetical-order */
  margin-top: 5px;

  ${({ $isOpenDelivery }) => accordionArrowAnimation($isOpenDelivery)}

  &:focus {
    outline-color: ${colours.OUTLINE_BORDER};
    outline-width: 2px;
  }
`;

export const ShippingSection = styled(ShippingSectionText)`
  margin-bottom: 0;
`;
